import { Navigate } from "react-router-dom";
import { useUserRole } from "../layouts/AppLayout";
import LoadingScreen from "./LoadingScreen";

/**
 * Renders children only if the user has at least one allowed role (same union rule as sidebar).
 * Use around page components to prevent deep-linking into another persona's primary workspace.
 */
export default function RoleGate({ allowedRoles, redirectTo, children }) {
  const { roles, rolesResolved } = useUserRole();

  if (!rolesResolved) {
    return <LoadingScreen message="Loading..." variant="light" />;
  }

  const ok = Array.isArray(allowedRoles) && allowedRoles.some((r) => roles.includes(r));
  if (!ok) {
    // Logged-in user with no roles in profile: avoid ping-pong between recruitment ↔ AM redirects.
    if (roles.length === 0) {
      return <Navigate to="/app/inbox" replace />;
    }
    return <Navigate to={redirectTo} replace />;
  }

  return children;
}
